module.exports = __webpack_public_path__ + "static/media/2-3.5e5722c3.mp3";